<template>
  <div class="about">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h1>About the North Coast Resource Hub</h1>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <p>
            The North Coast Resource Hub is a publicly available, mobile-friendly directory designed to make it easier to find health, social services, and other community resources across California’s North Coast. The Hub connects residents, families, service providers, and community partners with information about resources including health care, behavioral health, food, housing, transportation, family support, and other essential services.
          </p>
          <p>
            The North Coast Health Improvement and Information Network (NCHIIN) operates and maintains the Resource Hub as part of its work to strengthen connections between people, organizations, and services across the region. The Hub provides an accessible place to find locally relevant information and support stronger resource navigation across North Coast communities.
          </p>
          <p>
            The Resource Hub continues to grow and evolve as community needs and available services change. We welcome input from community members and partner organizations to help keep the directory useful, relevant, and responsive to the communities it serves.
          </p>
          <p>
            If you know of a resource that should be included, see information that needs to be updated, or have questions or suggestions about the North Coast Resource Hub, please contact Kerri Gowdy, Project Manager, at kgowdy@nchiin.org or 707-443-4563 x 157
          </p>
        </div>
      </div>
    </div>
    <div class="container" id="about-logos">
      <div class="row">
        <div class="col"><img class="logo-img" style="width: 100%;" src="@/assets/nchiin.png" alt="North Coast Health Improvement and Information Network"></div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'About',
  };
</script>

<style>
  .logo-img {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    max-width: 500px;
    max-height: 250px;
  }
</style>